import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface LoaderProps {
  loading: boolean;
  children?: React.ReactNode;
  size?: 'small' | 'default' | 'large';
  className?: string;
}

const getSpinIcon = (size?: 'small' | 'default' | 'large') => {
  const fontSize = size === 'small' ? 16 : size === 'large' ? 32 : 24;
  return <LoadingOutlined style={{ fontSize }} spin />;
};

/**
 * Spinner for loading over a child element without replacing the whole page content
 * @param loading: Boolean indicating if loading
 * @param children: Children elements
 * @constructor
 */
export const Loader = ({ loading, children, size, className }: LoaderProps) => {
  return (
    <Spin
      spinning={loading}
      indicator={getSpinIcon(size)}
      className={className}
    >
      {children}
    </Spin>
  );
};

/**
 * Full Screen Loader, replace whole page content and displays loader.
 * @constructor
 */
const FullScreenLoader = ({
  isMain,
  className,
  children,
}: {
  isMain?: boolean;
  className?: string;
  children?: React.ReactNode;
}) => (
  <>
    <div
      suppressHydrationWarning
      className={`full-screen-loader-overlay ${
        isMain ? 'full-screen-loader-overlay-absolute' : ''
      } ${className || ''}`}
    >
      {children}
      <Spin indicator={getSpinIcon('large')} />
    </div>
  </>
);
export default FullScreenLoader;
